import { __extends, __assign } from 'tslib';
import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-checkbox.css';

var getClassNameList$1 = classNames.bind(styles);
var UitkCheckbox = /** @class */ (function (_super) {
    __extends(UitkCheckbox, _super);
    function UitkCheckbox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            checked: props.checked
        };
        _this.handleChange = _this.handleChange.bind(_this);
        return _this;
    }
    UitkCheckbox.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.checked !== prevState.checked) {
            return {
                checked: nextProps.checked
            };
        }
        return null;
    };
    UitkCheckbox.prototype.handleChange = function (e) {
        var onChange = this.props.onChange;
        var checked = this.state.checked;
        this.setState({ checked: !checked });
        if (onChange) {
            onChange(e);
        }
    };
    UitkCheckbox.prototype.render = function () {
        var _a, _b;
        var _c = this.props, className = _c.className, children = _c.children, description = _c.description, disabled = _c.disabled, errorMessage = _c.errorMessage, id = _c.id, indeterminate = _c.indeterminate, labelClassName = _c.labelClassName, labelSuffix = _c.labelSuffix, name = _c.name, required = _c.required, value = _c.value, defaultChecked = _c.defaultChecked;
        var checked = this.state.checked;
        if (checked && defaultChecked) {
            console.error('Both checked and defaultChecked prop can`t be set it as true');
        }
        var checkedProp = defaultChecked ? 'defaultChecked' : 'checked';
        var checkedVal = defaultChecked || checked;
        var baseCssClass = 'uitk-checkbox';
        var wrapperClassNames = getClassNameList$1(baseCssClass, {
            'is-disabled': disabled
        });
        var labelCssClassNames = getClassNameList$1("uitk-checkbox-label", "uitk-checkbox-label-haslabelsuffix", (_a = {},
            _a[labelClassName] = Boolean(labelClassName),
            _a['is-required'] = required,
            _a));
        var inputClassNames = getClassNameList$1({
            checked: checked
        });
        var iconClassNames = getClassNameList$1('uitk-checkbox-icon');
        var controlClassNames = getClassNameList$1(baseCssClass + "-control");
        var contentClassNames = getClassNameList$1(baseCssClass + "-content");
        var labelContentClassNames = getClassNameList$1(baseCssClass + "-label-content");
        var labelSuffixClassNames = getClassNameList$1(baseCssClass + "-label-suffix");
        var descriptionClassNames = getClassNameList$1(baseCssClass + "-description uitk-type-200");
        var errorClassNames = getClassNameList$1(baseCssClass + "-error");
        var contents = children;
        return (React.createElement(UitkLayoutFlex, { className: wrapperClassNames, wrap: "nowrap" },
            React.createElement(UitkLayoutFlexItem, { shrink: 0, className: className },
                React.createElement("input", __assign({ type: "checkbox", name: name || id, id: id }, (_b = {}, _b[checkedProp] = checkedVal, _b), { className: inputClassNames, disabled: disabled, onChange: this.handleChange, value: value, "aria-describedby": errorMessage ? id + "-error" : undefined, "aria-invalid": errorMessage ? true : undefined, "aria-required": required }))),
            React.createElement(UitkLayoutFlexItem, { className: controlClassNames, shrink: 0 },
                React.createElement("span", { "aria-hidden": "true" }, checkedVal && React.createElement(UitkIcon, { name: indeterminate ? 'remove' : 'check', className: iconClassNames }))),
            React.createElement(UitkLayoutFlexItem, { className: contentClassNames, grow: 1 },
                React.createElement("div", null,
                    React.createElement("label", { className: labelCssClassNames, htmlFor: id },
                        React.createElement("span", { className: labelContentClassNames }, contents),
                        labelSuffix && React.createElement("span", { className: labelSuffixClassNames }, labelSuffix),
                        description && React.createElement("span", { className: descriptionClassNames }, description)),
                    errorMessage && (React.createElement("p", { className: errorClassNames, id: id + "-error" }, errorMessage))))));
    };
    UitkCheckbox.displayName = 'UitkCheckbox';
    UitkCheckbox.defaultProps = {
        checked: false
    };
    return UitkCheckbox;
}(React.Component));

var getClassNameList = classNames.bind(styles);
var UitkCheckboxGroup = /** @class */ (function (_super) {
    __extends(UitkCheckboxGroup, _super);
    function UitkCheckboxGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkCheckboxGroup.prototype.render = function () {
        var _a = this.props, children = _a.children, errorMessage = _a.errorMessage, group = _a.group, legendLabel = _a.legendLabel;
        return (React.createElement("fieldset", { className: getClassNameList('uitk-checkbox-group') },
            React.createElement("legend", { className: getClassNameList('is-visually-hidden') }, legendLabel || group),
            errorMessage && React.createElement("p", { className: getClassNameList('uitk-checkbox-error') }, errorMessage),
            children));
    };
    UitkCheckboxGroup.displayName = 'UitkCheckboxGroup';
    return UitkCheckboxGroup;
}(React.Component));

export { UitkCheckbox, UitkCheckboxGroup };
